// extracted by mini-css-extract-plugin
var _1 = "wpfLu";
export { _1 as "fallbackIcon" }
